module.exports = __webpack_public_path__ + "static/media/menu_bg.5281c8aa.png";